import React from "react";

function Footer() {
    return (
        <div>
            <footer className="main-footer">
                <div className="company-details footer-context small-font">
                    <h1 className="logo-image">DataHedge</h1>
                    <p className="font-normal footer-description">Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa
                        doloremque itaque ullam atque nostrum, fuga voluptatem ab, natus expedita harum rem asperiores
                        dolore impedit! Asperiores obcaecati modi saepe commodi eligendi?</p>
                </div>
                <div className="products-box  footer-context small-font">
                    <h2>Products</h2>
                    <ul className="products lists">
                        <li><a href="https://github.com/skabdulhaq" className="footer-link">Algo-1</a></li>
                        <li><a href="https://github.com/skabdulhaq" className="footer-link">Algo-2</a></li>
                    </ul>
                </div>
                <div className="follow-us  footer-context small-font">
                    <h2>Follow us on</h2>
                    <div className="social-imgs">
                        <a href="https://github.com/skabdulhaq" className="footer-link">
                            <ion-icon class="icon-footer" name="logo-instagram"></ion-icon>
                        </a>
                        <a href="https://github.com/skabdulhaq" className="footer-link">
                            <ion-icon class="icon-footer" name="logo-facebook"></ion-icon>
                        </a>
                        <a href="https://github.com/skabdulhaq" className="footer-link">
                            <ion-icon class="icon-footer" name="logo-linkedin"></ion-icon>
                        </a>
                        <a href="https://github.com/skabdulhaq" className="footer-link">
                            <ion-icon class="icon-footer" name="logo-twitter"></ion-icon>
                        </a>
                    </div>
                    <ul className="lists">
                        <li><a href="https://github.com/skabdulhaq" className="footer-link">Terms and Conditions</a></li>
                        <li><a href="https://github.com/skabdulhaq" className="footer-link">Privacy Policy</a></li>
                    </ul>
                </div>
                <div className="contact-box footer-context  small-font">
                    <h2>Contact</h2>
                    <div className="lists">
                        <div className="contact ">
                            <ion-icon class="location-icon" name="location-outline"></ion-icon>
                            <p>Lorem ipsum dolor sit amet consectetur </p>
                        </div>
                        <div className="contact ">
                            <ion-icon class="icon-footer" name="mail-outline"></ion-icon>
                            <p>xxxxx@mail.com</p>
                        </div>
                        <div className="contact">
                            <ion-icon class="icon-footer" name="call-outline"></ion-icon>
                            <p>00000000000</p>
                        </div>
                    </div>
                </div>
                <div id="creator" className="cp-rights  footer-context  small-font">
                    <p> Made by <a className="footer-link reverse-effect" href="https://www.github.com/skabdulhaq">Abdul Haq</a>
                        & special thanks to <a className="footer-link reverse-effect" href="https://github.com/skabdulhaq">Sailendra</a>  </p>
                </div>
                <div className="cp-rights  footer-context  small-font" id="cprights">
                    <p> Copyrights &copy; Datahedge 2022 </p>
                </div>
            </footer>
        </div>
    )
}

export default Footer